/*
 * Hapag-Lloyd Kreuzfahrten (hl-kreuzfahrten.de)
 *
 * 2014 – 2015 sitegeist media solutions GmbH
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of sitegeist media solutions GmbH and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to sitegeist media solutions GmbH
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from sitegeist media solutions GmbH.
 *
 */

import { component } from '@reduct/component';

@component()
class TouchSwipeEmitter {
	constructor() {
		this.xDown = null;
		this.yDown = null;

		this.getElement().addEventListener('touchstart', this.handleTouchStart.bind(this), false);
		this.getElement().addEventListener('touchmove', this.handleTouchMove.bind(this), false);
	}

	handleTouchStart(e) {
		const firstTouchPoint = e.touches[0];

		this.xDown = firstTouchPoint.clientX;
		this.yDown = firstTouchPoint.clientY;
	}

	handleTouchMove(e) {
		const { xDown, yDown } = this;
		const firstTouchPoint = e.touches[0];
		const xUp = firstTouchPoint.clientX;
		const yUp = firstTouchPoint.clientY;
		const xDiff = xDown - xUp;
		const yDiff = yDown - yUp;

		if (!xDown || !yDown) {
			return;
		}

		if (Math.abs(xDiff) > Math.abs(yDiff)) {
			if (xDiff > 0) {
				this.trigger('swipeLeft');
			} else {
				this.trigger('swipeRight');
			}
		} else {
			if (yDiff > 0) {
				this.trigger('swipeUp');
			} else {
				this.trigger('swipeDown');
			}
		}

		this.xDown = null;
		this.yDown = null;
	}
}

export default TouchSwipeEmitter;
